/*
* FIXME: This module is a duplicate of fields/EquipmentInput
* Figure out how to reconcile their usages.
*
* Usages:
*  1) TimeEntryFormComponents > ?
 */
import React, { Component } from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { propType } from 'graphql-anywhere';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

import { querySelector } from '../../../../utils';

export class EquipmentInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleOnFocus = this.handleOnFocus.bind(this);
    this.handleOnToggle = this.handleOnToggle.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  handleCancel() {
    this.props.onChange(null);
  }

  handleOnFocus(e) {
    this.handleOnToggle(true);
  }

  handleOnToggle(open) {
    this.setState({
      open,
    });
  }

  render() {
    const {
      equipment, value, disabled, onChange,
    } = this.props;
    const { open } = this.state;

    return (
      <InputGroup>
        {
          /*
            The on mouse down prevents the 'onClick' from firing. This was toggling the dropdown
            twice. If you have a better way of prevent the double toggle by all means implement it.
          */
        }
        <DropdownList
          disabled={disabled}
          inputProps={{
            className: 'form-control',
          }}
          filter="contains"
          value={value}
          data={equipment}
          open={open}
          onToggle={this.handleOnToggle}
          onFocus={this.handleOnFocus}
          onMouseDown={(e) => { e.preventDefault(); }}
          onChange={onChange}
          valueField="id"
          textField="equipment_number"
        />
        <InputGroup.Button>
          <Button
            name="cancel"
            tabIndex="-1"
            disabled={!value}
            onClick={this.handleCancel}
          >
            <Glyphicon glyph="remove" />
          </Button>
        </InputGroup.Button>
      </InputGroup>
    );
  }
}

const EquipmentInputEquipmentFragment = gql`
  fragment EquipmentInputEquipment on Equipment {
    id
    equipment_number
  }
`;

const AllEquipmentQuery = gql`
  query AllEquipment {
    all_equipment {
      edges {
        node {
          ...EquipmentInputEquipment
        }
      }
    }
  }
  ${EquipmentInputEquipmentFragment}
`;

const CreateEquipmentMutation = gql`
  mutation CreateEquipment($input: EquipmentCreateInput!) {
    equipment_create(input: $input) {
      ...EquipmentInputEquipment
    }
  }
  ${EquipmentInputEquipmentFragment}
`;

const marshallData = ({ data, ownProps }) => {
  const equipment = querySelector(data, '$.all_equipment.edges[*].node', []);
  return {
    ...ownProps,
    data,
    equipment,
  };
};

const withApi = compose(
  graphql(AllEquipmentQuery, { props: marshallData, options: { fetchPolicy: 'network-only' } }),
  graphql(CreateEquipmentMutation, { name: 'createEquipment' }),
);

const propTypes = {
  disabled: PropTypes.bool,
  value: propType(EquipmentInputEquipmentFragment),
  onChange: PropTypes.func.isRequired,

  /* eslint-disable react/forbid-prop-types */
  /* eslint-disable react/require-default-props */
  equipment: PropTypes.arrayOf(propType(EquipmentInputEquipmentFragment)).isRequired,
};

const defaultProps = {
  disabled: false,
  value: null,
};

EquipmentInput.propTypes = propTypes;
EquipmentInput.defaultProps = defaultProps;

export default withApi(EquipmentInput);
